import { render } from "./LibraryAlbum2.vue?vue&type=template&id=670ebba6&ts=true"
import script from "./LibraryAlbum2.vue?vue&type=script&lang=ts"
export * from "./LibraryAlbum2.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\vdmar\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__